import * as Yup from 'yup'

const validation = {
    // certificatesValidation: Yup.object().shape({
    //     certificates: Yup.array().of(
    //         Yup.object().shape({
    //             certificate_attachment: Yup.mixed()
    //                 .required('Please attach a file'),
    //         })
    //     ),
    // }),
    companySchema: Yup.object().shape({
        companies: Yup.array()
            .of(
                Yup.object().shape({
                    first_name: Yup.string()
                        .required('First Name is required')
                        .matches(
                            /^[A-Za-z]+$/,
                            'First Name can only contain letters'
                        ),
                    last_name: Yup.string()
                        .required('Last Name is required')
                        .matches(
                            /^[A-Za-z]+$/,
                            'Last Name can only contain letters'
                        ),
                    company: Yup.object()
                        .nullable()
                        .required('Company is required'),
                    street_address: Yup.string().required(
                        'Street Address is required'
                    ),
                    phone_number: Yup.string()
                        .required('Phone Number is required')
                        .matches(/^[0-9]+$/, 'Phone Number must be numeric')
                        .max(
                            20,
                            'Phone Number must not be greater than 20 characters'
                        ),
                })
            )
            .required(),
    }),

    representativeSchema: Yup.object().shape({
        companiesRepresentative: Yup.array()
            .of(
                Yup.object().shape({
                    first_name: Yup.string()
                        .required('First Name is required')
                        .matches(
                            /^[A-Za-z]+$/,
                            'First Name can only contain letters'
                        ),
                    last_name: Yup.string()
                        .required('Last Name is required')
                        .matches(
                            /^[A-Za-z]+$/,
                            'Last Name can only contain letters'
                        ),
                    designation: Yup.string().required(
                        'Designation is required'
                    ),
                    phone: Yup.string()
                        .required('Phone Number is required')
                        .matches(/^[0-9]+$/, 'Phone Number must be numeric')
                        .max(
                            20,
                            'Phone Number must not be greater than 20 characters'
                        ),
                    contacts: Yup.array().of(
                        Yup.object().shape({
                            contactNumber: Yup.string()
                                .required('Phone Number is required')
                                .matches(
                                    /^[0-9]+$/,
                                    'Phone Number must be numeric'
                                )
                                .max(
                                    20,
                                    'Phone Number must not be greater than 20 characters'
                                ),
                        })
                    ),
                })
            )
            .required(),
    }),

    inviteConnectionValidation: Yup.object({
        name: Yup.string().required('Name is required').max(160),
        email: Yup.string().email().required('Email is required'),
    }),
    feedbackValidation: Yup.object({
        subject: Yup.string().required('Subject is required').max(160),
        description: Yup.string().required('Message is required'),
        type: Yup.string().required('Type is required'),
    }),
    createJobValidation: Yup.object({
        jobTitle: Yup.string().required('Job title is required').max(160),
        street: Yup.string().required('Street is required'),
        city: Yup.object()
            .shape({
                label: Yup.string(),
                id: Yup.number(),
            })
            .nullable()
            .required('City is required.'),
        state: Yup.object()
            .shape({
                label: Yup.string(),
                id: Yup.number(),
            })
            .nullable()
            .required('State is required.'),
        zipCode: Yup.string().required('Zip Code is required'),
        // biddingStartDate: Yup.string().required("Password is required"),
        // biddingCloseDate: Yup.string().required("Password is required"),
        jobDesc: Yup.string().required('Job Description is required'),
        jobStatus: Yup.string().required('Job Status is required').nullable(),
        services: Yup.array().of(Yup.object()).min(1, 'at least 1 service'),
        budget: Yup.number()
            .nullable()
            .transform((value, originalValue) => {
                if (
                    originalValue === '' ||
                    originalValue === null ||
                    originalValue === undefined
                ) {
                    return null
                }
                return value
            })
            .typeError('Budget must be a number')
            .positive('Budget must be a positive number'),
        jobStartDate: Yup.string().required('Job start Date is required'),
        biddingStartDate: Yup.string().required(
            'Bidding Start  Date is required'
        ),
        biddingCloseDate: Yup.string().required(
            'Bidding Close  Date is required'
        ),
    }),
    uploadProjectValidation: Yup.object({
        projectName: Yup.string()
            .required('Project title is required')
            .max(160),
        projectCity: Yup.object()
            .shape({
                label: Yup.string(),
                id: Yup.number(),
            })
            .nullable()
            .required('Project city is required.'),
        projectState: Yup.object()
            .shape({
                label: Yup.string(),
                id: Yup.number(),
            })
            .nullable()
            .required('Project state is required.'),
        projectDescription: Yup.string().required(
            'Project description is required'
        ),
        projectBudget: Yup.number()
            .required('Project budget is required')
            .typeError('Budget must be a number')
            .positive('Budget must be a positive number'),
        projectStart: Yup.string().required('Project start is required'),
        projectEnd: Yup.string().required('Project end is required'),
    }),
    servicesInputValidaion: Yup.object({
        inviteProConnection: Yup.string().required('Field is required'),
        inviteEmail: Yup.string().email('email').required('Field is required'),
    }),

    signupValidation: Yup.object({
        firstName: Yup.string()
            .matches(/^[A-Za-z]+$/, 'First Name can only contain alphabets')
            .required('First Name is required'),
        lastName: Yup.string()
            .matches(/^[A-Za-z]+$/, 'Last Name can only contain alphabets')
            .required('Last Name is required'),
        email: Yup.string()
            .email('Please enter a valid email address')
            .required('Email Address is required'),
        userType: Yup.string().required('User Type is required'),
        password: Yup.string()
            .required('Password is required')
            .min(8, 'Password must be at least 8 characters')
            .max(16, 'Password must not exceed 16 characters')
            // .max(40, 'Password must not exceed 16 characters'),
            .matches(
                /[A-Z]/,
                'Password must contain at least one uppercase letter'
            )
            .matches(
                /[a-z]/,
                'Password must contain at least one lowercase letter'
            )
            .matches(
                /[\W_]/,
                'Password must contain at least one special character'
            ),
        confirmPassword: Yup.string()
            .required('Re-Password is required')
            .oneOf(
                [Yup.ref('password'), null],
                'Password and confirm password do not match'
            ),
        acceptPolicy: Yup.bool()
            .oneOf(
                [true],
                'You must accept Privacy Policy | Terms and Condition'
            )
            .required('You must accept Privacy Policy | Terms and Condition'),
    }),
    createProposalValidation: Yup.object({
        bid_amount: Yup.string().required('Bid Amount is required'),
        bid_duration: Yup.string().required('Bid Duration is required'),
        proposal_bid_note: Yup.string().required('Bid Note is required'),
    }),

    createBSProject: Yup.object({
        jobTitle: Yup.string().required('Job title is required').max(160),
        street: Yup.string().required('Street is required'),
        city: Yup.object()
            .shape({
                label: Yup.string(),
                id: Yup.number(),
            })
            .nullable()
            .required('City is required.'),
        state: Yup.object()
            .shape({
                label: Yup.string(),
                id: Yup.number(),
            })
            .nullable()
            .required('State is required.'),
        zipCode: Yup.string().required('ZipCode is required'),
        jobDesc: Yup.string().required('Job Description is required'),
        services: Yup.array().of(Yup.object()).min(1, 'at least 1 service'),
    }),

    pdfRename: Yup.object({
        pdfTitle: Yup.string().required('Field is required'),
    }),

    productValidation: Yup.object({
        title: Yup.string().required('Please enter Product name'),
        brandName: Yup.object()
            .typeError('Brand Name is Required')
            .required('Brand Name is Required'),
        category: Yup.object().typeError('Category is Required').required(''),
        colors: Yup.array()
            .of(
                Yup.object({
                    // finish: Yup.array().min(
                    //     1,
                    //     'At least one Finish is required'
                    // ),
                    // joint: Yup.string().required("Joint is required"),
                    // primer_id: Yup.string().required("Primer is required"),
                    // material_id : Yup.string().required("Material is required"),
                    // pattern : Yup.string().required("Material is required"),
                    // first_coat : Yup.string().required("Material is required"),
                    // second_coat : Yup.string().required("Material is required"),
                    // glass_type : Yup.string().required("Glass Type is required"),
                })
            )
            .min(1, 'At least one Finish is required'),
        // size: Yup.string().lowercase().notOneOf(['small','medium','large', 'extra Large','extra-large', 'extralarge', null], 'Cannot be Small, Medium, Large, Extra Large'),
        measurements: Yup.array()
            .of(
                Yup.object({
                    width: Yup.number()
                        .typeError('Must be a number')
                        .max(100, 'Cannot exceed 100')
                        .required('Required'),
                    depth: Yup.number()
                        .typeError('Must be a number')
                        .max(100, 'Cannot exceed 100')
                        .required('Required'),
                    length: Yup.number()
                        .typeError('Must be a number')
                        .max(100, 'Cannot exceed 100')
                        .required('Required'),
                    height: Yup.number()
                        .typeError('Must be a number')
                        .max(100, 'Cannot exceed 100')
                        .required('Required'),
                    weight: Yup.number()
                        .typeError('Must be a number')
                        .max(100, 'Cannot exceed 100')
                        .required('Required'),
                    //delivery_time: Yup.number().max(100, "Cannot exceed 100").required("Required"),
                })
            )
            .min(1, 'Select atleast 1 Measurement'),

        prices: Yup.array().of(
            Yup.object({
                price: Yup.number()
                    .typeError('Must be a number')
                    .max(100000, 'Cannot exceed 100000')
                    .required('Required'),
                quantity: Yup.number()
                    .typeError('Must be a number')
                    .max(100000, 'Cannot exceed 100000')
                    .required('Required'),
                discount_price: Yup.number()
                    .typeError('Must be a number')
                    .max(100000, 'Cannot exceed 100000'),
                //color_image: Yup.object().required("Required")
            })
        ),
    }),
    profileValidation: Yup.object().shape({
        contactFirstName: Yup.string().required(
            'Contact First Name is required'
        ),
        contactLastName: Yup.string().required('Contact Last Name is required'),
        companyName: Yup.string().required('Company Name is required'),
        companyStreetAddress: Yup.string().required(
            'Company Street Address is required'
        ),
        companyState: Yup.mixed().required('Company State is required'),
        companyCity: Yup.mixed().required('Company City is required'),
        companyZip: Yup.string().required('Company Zip is required'),
        yearEst: Yup.string().required('Year Est. is required'),
        companyPhone: Yup.string()
            .required('Phone number is required')
            .matches(
                /^\d{3} \d{3} \d{4}$/,
                'Phone number must be in the format 123 456 7890'
            ),
        companyEmailAddress: Yup.string()
            .email('Invalid email')
            .required('Company Email Address is required'),
        website: Yup.string().nullable(),
    }),
    // profileValidation: Yup.object().shape({
    //     contactFirstName: Yup.string().required('Contact First Name is required'),
    //     contactLastName: Yup.string().required('Contact Last Name is required'),
    //     companyName: Yup.string().required('Company Name is required'),
    //     companyStreetAddress: Yup.string().required('Company Street Address is required'),
    //     companyState: Yup.mixed().required('Company State is required'),
    //     companyCity: Yup.mixed().required('Company City is required'),
    //     companyZip: Yup.string().required('Company Zip is required'),
    //     yearEst: Yup.string().required('Year Est. is required'),
    //     companyPhone: Yup.string()
    //         .matches(/^\S*$/, 'Spaces are not allowed')
    //         .matches(/^[0-9]+$/, 'Only numbers are allowed')
    //         .required('Company Phone is required'),
    //     companyEmailAddress: Yup.string().email('Invalid email').required('Company Email Address is required'),
    //     website: Yup.string().required('Website is required'),
    // }),
    docAndRegistrationValidation: Yup.object().shape({
        licensedProfession: Yup.mixed().required('Required'),
        bonded: Yup.string().required('Required'),

        // --- General Liability Insurance Status ---
        generalLiabilityInsurance: Yup.string().required('Required'),

        // --- Worker's Comp Status ---
        workersComp: Yup.string().required('Required'),

        // --- GLI Policy Number (Required conditionally) ---
        gliPolicy: Yup.string()
            .matches(
                /^[a-zA-Z0-9-]*$/,
                'Only letters, numbers, and dashes are allowed'
            )
            .max(40, 'Policy number must not exceed 40 characters')
            .nullable(),
        // .when('generalLiabilityInsurance', {
        //     // Check the GLI status field
        //     is: 'YES', // If the status is 'Yes'
        //     then: (schema) =>
        //         schema.required(
        //             'GLI Policy number is required when status is Yes'
        //         ), // Make it required
        //     otherwise: (schema) => schema.nullable(), // Otherwise, allow null/empty
        // }),

        // --- WC Policy Number (Required conditionally) ---
        wcPolicy: Yup.string()
            .matches(
                /^[a-zA-Z0-9-]*$/,
                'Only letters, numbers, and dashes are allowed'
            )
            .max(40, 'Policy number must not exceed 40 characters')
            .nullable(),
        // .when('workersComp', {
        //     // Check the Worker's Comp status field
        //     is: 'YES', // If the status is 'Yes'
        //     then: (schema) =>
        //         schema.required(
        //             'Worker’s Comp Policy number is required when status is Yes'
        //         ), // Make it required
        //     otherwise: (schema) => schema.nullable(), // Otherwise, allow null/empty
        // }),

        // --- Other GLI Fields (Required conditionally) ---
        gliPolicyMax: Yup.string().matches(
            /^[0-9]*$/,
            'Only numbers are allowed'
        ),
        // .when('generalLiabilityInsurance', {
        //     is: 'YES',
        //     then: (schema) => schema.required('GLI Policy Max is required'),
        //     otherwise: (schema) => schema.nullable(),
        // }),
        gliAgentPhoneNumber: Yup.string().when('generalLiabilityInsurance', {
            is: 'YES',
            then: (schema) => schema.required('Required'),
            otherwise: (schema) => schema.nullable(),
        }),
        gliAgentStreetAddress: Yup.string().when('generalLiabilityInsurance', {
            is: 'YES',
            then: (schema) => schema.required('Required'),
            otherwise: (schema) => schema.nullable(),
        }),
        gliInsuranceCompanyName: Yup.string().when(
            'generalLiabilityInsurance',
            {
                is: 'YES',
                then: (schema) => schema.required('Required'),
                otherwise: (schema) => schema.nullable(),
            }
        ),
        gliAgentBusinessName: Yup.string().when('generalLiabilityInsurance', {
            is: 'YES',
            then: (schema) => schema.required('Required'),
            otherwise: (schema) => schema.nullable(),
        }),
        gliAgentLastName: Yup.string().when('generalLiabilityInsurance', {
            is: 'YES',
            then: (schema) => schema.required('Required'),
            otherwise: (schema) => schema.nullable(),
        }),
        gliAgentFirstName: Yup.string().when('generalLiabilityInsurance', {
            is: 'YES',
            then: (schema) => schema.required('Required'),
            otherwise: (schema) => schema.nullable(),
        }),

        // --- Other WC Fields (Required conditionally) ---
        wcPolicyMax: Yup.string().matches(
            /^[0-9]*$/,
            'Only numbers are allowed'
        ),
        // .when('workersComp', {
        //     is: 'YES',
        //     then: (schema) => schema.required('WC Policy Max is required'),
        //     otherwise: (schema) => schema.nullable(),
        // }),
        wcAgentPhoneNumber: Yup.string().when('workersComp', {
            is: 'YES',
            then: (schema) => schema.required('Required'),
            otherwise: (schema) => schema.nullable(),
        }),
        wcAgentStreetAddress: Yup.string().when('workersComp', {
            is: 'YES',
            then: (schema) => schema.required('Required'),
            otherwise: (schema) => schema.nullable(),
        }),
        wcInsuranceCompanyName: Yup.string().when('workersComp', {
            is: 'YES',
            then: (schema) => schema.required('Required'),
            otherwise: (schema) => schema.nullable(),
        }),
        wcAgentBusinessName: Yup.string().when('workersComp', {
            is: 'YES',
            then: (schema) => schema.required('Required'),
            otherwise: (schema) => schema.nullable(),
        }),
        wcAgentLastName: Yup.string().when('workersComp', {
            is: 'YES',
            then: (schema) => schema.required('Required'),
            otherwise: (schema) => schema.nullable(),
        }),
        wcAgentFirstName: Yup.string().when('workersComp', {
            is: 'YES',
            then: (schema) => schema.required('Required'),
            otherwise: (schema) => schema.nullable(),
        }),
    }),

    servicesValidation: Yup.object().shape({
        constructionType: Yup.string().required(
            'Construction Type is required'
        ),
        licensedService: Yup.mixed().nullable(),
        otherService: Yup.mixed().nullable(),
    }),
}

export default validation
